import { type JSX } from 'react';

/**
 * DAS SCHLIESSKREUZ (Auftrag CRM-102).
 *
 * Wunsch des Auftraggebers (07.10.2026): Jedes Pop-up schließt mit einem X.
 * Bis dahin trug nur der Dialog eines; Suchfenster, Artikelwahl, Maskenhilfe,
 * Kurzkarte und die Glocke schlossen nur über Esc, einen Klick daneben oder
 * den Öffner. Auf dem iPad gibt es kein Esc, und „daneben tippen" sucht man.
 *
 * Ein Baustein und kein zweiter Stil: Alle Kreuze sehen aus wie das des
 * Dialogs und heißen für eine Vorlesehilfe „Schließen". Der Dialog nennt
 * seinen Titel mit („Modul 3 schließen") — dort liegen mehrere Fenster im
 * Verlauf eines Vorgangs, und der Titel sagt, welches zugeht.
 *
 * Der Baustein setzt keinen Fokus: Wohin er nach dem Schließen geht, weiß nur
 * das Pop-up — es kennt seinen Auslöser. Beim Öffnen springt der Fokus in den
 * Inhalt und nicht auf das Kreuz; das regelt ebenfalls das Pop-up.
 *
 * Sichtbar 36 px wie jeder Knopf; die Trefferfläche reicht über einen
 * unsichtbaren Rand auf 44 px (WCAG 2.5.5, Finger auf dem iPad), ohne dass
 * das Kreuz größer aussieht als im Dialog.
 */
export function Schliesskreuz({
  beiKlick,
  beschriftung = 'Schließen',
}: {
  readonly beiKlick: () => void;
  readonly beschriftung?: string;
}): JSX.Element {
  return (
    <button type="button" className="schliesskreuz" aria-label={beschriftung} onClick={beiKlick}>
      ×
    </button>
  );
}
